import React from 'react';
import { TouchableOpacity, View, Text, Image, Platform } from 'react-native';
import styles from '../InternalComponents/styles/style';
import Autocomplete from '../../components/customAutoComplete';
import { getResponsiveStyle } from '../../utils/appUtils';
import AsyncStorage from '@react-native-community/async-storage';
import {
  AUTH,
  CSR,
  DeActivateToken,
  getService,getGoogleLocation
} from '../../network/request/apirequests.js';
import { hocComponentFetcherWithLoader } from '../../components';
import { AppConsumer } from '../../AppContext';
import ApiTag from '../../network/request/apiTags';
import {
  ALL_CONSTANTS,
} from '../../constants/displayConstants';
import CustomBootbox from '../../components/CustomBootbox';
const x_stu_O = 'AIzaSyCcFtl0ekH3uaG2eF6YklOoPPPR2LWr-6o';
const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 8000,
  autoplaySpeed: 8000,
  cssEase: 'linear',
  rtl: false
};

const checkNull = (value) => !value || value === undefined || value === '';

class Topsection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueSelected: '',
      searchFlag: true,
      searchArray: '',
      searchAll: true,
      stateId: 1,

      // * location in header related states
      userIp: '',
      longitude: '',
      latitude: '',
      location: '',
    };
    this.makeAPICall = props.makeAPICall;
  }

  componentDidMount() {
    // * fetch location and ip from session
    const location = sessionStorage.getItem('location');
    const userIp = sessionStorage.getItem('userIp');
    const longitude = sessionStorage.getItem('longitude');
    const latitude = sessionStorage.getItem('latitude');

    if (
      checkNull(location) &&
      checkNull(userIp) &&
      checkNull(longitude) &&
      checkNull(latitude)
    ) {
      this.fetchIpLocation(); // * only fetch IP Location on component mount
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.getCoordinates,
          this.handleLocationError,
        );
      }
      } else {
        this.setState({
          bootboxtext: ALL_CONSTANTS.ENABLE_LOCATION,
          headerText: '',
          Blackout: true,
          userAddress: location,
          userIp,
          longitude,
          latitude,
        });
      }
    let id = 1;
    const pathName = window.location.pathname;
    switch (true) {
      case pathName.includes(ALL_CONSTANTS.PROFILE_PATH):
        id = 1;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.ACCOUNT_PATH):
        id = 2;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.CREDIT_CARD_PATH):
        id = 3;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.LOAN_PATH):
        id = 4;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.DEPOSITS_PATH):
        id = 5;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH):
        id = 7;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.FOREX_PATH):
        id = 8;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.ATMDEBIT_PATH):
        id = 9;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.OTHERURL_PATH):
        id = 9;
        this.state.searchAll = false;
        break;
      default:
        null;
    }
    this.state.stateId = id;
    this.getservicelist();
  }

  handleLocationError = error => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        this.setState({
          userIdle: true,
          bootboxtext:
            '\n\nLooks like your location permission is blocked for entered website. Please provide location access to proceed further. Here’s how you can navigate:\n\nIf you are using laptop/ desktop:\n\nChrome Settings / More Settings by clicking on right top browser settings menu >> Privacy & Security >> Site Settings >> Permissions >> Location >> Select Enable/ Allow for https://service.icicibank.com\n\nIf you are using mobile device:\n\nSettings >> Site Settings/ App Settings >> Permissions >> Location >> Chrome >> Enable/ allow for https://service.icicibank.com',
          headerText: 'Your Location access is blocked',
          openmodel: true,
        });
        console.log('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        console.log('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        console.log('The request to get user location timed out.');
        break;
      case error.UNKNOWN_ERROR:
        console.log('An unknown error occurred.');
        break;
    }
  };

  componentWillReceiveProps(newprops) {
    // this.fetchIpLocation();
    this.setState({
      searchFlag: newprops.isSearch
    });
  }

  getservicelist = id => {
    var that = this;
    var fieldData = {};
    if (this.state.searchAll == true) {
      fieldData = {
        number: 'high',
        dynamicSearch: "false"
      };
    } else {
      fieldData = {
        number: this.state.stateId,
        dynamicSearch: "true"
      };
    }
    this.makeAPICall(
      getService(fieldData, CSR),
      this.onDataReceived,
      this.onError
    );
  };

  onError = err => {
    
    if (ApiTag.GETSERVICE == err.tag) {
      // NULL
    } else if (ApiTag.Menu_Option == err.tag) {
      // NULL
    } else if (ApiTag.GETGOOGLELOC == err.tag) {
    }
  };
  getCoordinates = position => {
    this.setState({
      longitude: position.coords.longitude,
      latitude: position.coords.latitude
    });
    sessionStorage.setItem('longitude', position.coords.longitude);
    sessionStorage.setItem('latitude', position.coords.latitude);
    this.reverseGeoCode();
  };

  navigateHomescreen = async () => {
    this.removeToken();
    if (this.props.navigation) {
      window.location.reload(false);
      this.props.navigation.navigate('HomePage');
    }
  };

  removeToken = async () => {
    let userToken;
    if (Platform.OS === 'web') {
      userToken = sessionStorage.getItem('token');
    } else {
      userToken = await AsyncStorage.getItem('token');
    }
    var fieldData = {
      "token": userToken,
    };
    this.makeAPICall(
      DeActivateToken(fieldData, AUTH),
      this.onDataReceived,
      this.onError
    );
  };

  onDataReceived = async response => {
    this.setState({ loading: false });
    var that = this;
    if (ApiTag.DEACTIVATE_TOKEN == response.tag) {
      if (response.data.status === 200) {
        if (Platform.OS === 'web') {
          sessionStorage.removeItem('token');
        } else {
          await AsyncStorage.removeItem('token');
        }
      }
    } else if (ApiTag.GETSERVICE == response.tag) {
      let array = [];
      for (let i = 0; i < response.data.data.length; i += 1) {
        if (response.data.data[i]['images'] === null) {
          var ServiceImages = require('../../assets/images/icon_email.png');
        } else {
          var ServiceImages = response.data.data[i]['images'];
        }
        let dataArray = [];
        Object.keys(response.data.data[i]).map((key, val, item) => {
          dataArray = {
            id: response.data.data[i]['servicename'],
            serviceId: response.data.data[i]['serviceId'],
            servicename: response.data.data[i]['servicename'],
            title: response.data.data[i]['servicename'],
            serviceType: response.data.data[i]['serviceType'],
            images: ServiceImages,
            dynamicStatus: response.data.data[i]['dynamicStatus'],
            menuname: response.data.data[i]['menuname'],
            dynamicMessage: response.data.data[i]['message'],
            dynamicMenuType: response.data.data[i]['menuType'],
            keywordSearch: response.data.data[i]['keywordSearch'],
            displayName: response.data.data[i]['displayMessage'],
            timeFlag: response.data.data[i]['timeFlag'],
          };
        });
        array.push(dataArray);
      }
      this.setState({
        searchArray: array
      });
    }else if (ApiTag.GETGOOGLELOC == response.tag) {
      this.setState({
              userAddress: response.data.data?.address
            });
            sessionStorage.setItem(
              'location',
              response.data.data?.address
            );
    }
  };

  reverseGeoCode = () => {
    let fieldData = {
      "geoLat":String(this.state.latitude),
      "geoLong": String(this.state.longitude),
      // "geoLat": "15.6835224",
      //   "geoLong": "74.6680036",
    };
    this.makeAPICall(
      getGoogleLocation(fieldData, AUTH),
      this.onDataReceived,
      this.onError
    );
    // fetch(
    //   `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.state.latitude},${this.state.longitude}&sensor=true&key=${x_stu_O}`
    // )
    //   .then(response => response.json())
    //   .then(data => {
    //     this.setState({
    //       userAddress: data.plus_code.compound_code.substring(8)
    //     });
    //     sessionStorage.setItem(
    //       'location',
    //       data.plus_code.compound_code.substring(8)
    //     );
    //   })
    //   .catch(error => error);
  };
  fetchIpLocation() {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        this.setState({
          userIp: data.ip
        });
        sessionStorage.setItem('userIp', data.ip);
      })
      .catch(error => this.setState({ userIp: 0 }));
  }
  onSubmit = async () => {
    this.setState({ searchFlag: true });
  };
  refresh() {
    var clear = [
      'time',
      'product_name',
      'payment_gateway',
      'stopwatch',
      'credit_opted',
      'flow',
      'easyPay',
      'token',
    ];

    clear.map(item => {
      sessionStorage.removeItem(item);
    });
  }
  closebootbox = () => {
    if (this.state.userIdle) {
      this.refresh();
      window.removeEventListener('keydown', this.handleKeyPress);
      if (Platform.OS == 'web') {
        const pathName = window.location.pathname;
        const domainName = window.location.origin;

        const path = [
          ALL_CONSTANTS.PROFILE_PATH,
          ALL_CONSTANTS.ACCOUNT_PATH,
          ALL_CONSTANTS.CREDIT_CARD_PATH,
          ALL_CONSTANTS.LOAN_PATH,
          ALL_CONSTANTS.DEPOSITS_PATH,
          ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH,
          ALL_CONSTANTS.FOREX_PATH,
          ALL_CONSTANTS.DUE_PATH,
          ALL_CONSTANTS.OTHERURL_PATH
        ];

        let updatedPath = pathName.substr(0, pathName.lastIndexOf('/'));
        if (path.includes(updatedPath)) {
          window.location.href = `${domainName}${updatedPath}`;
          return;
        } else {
          window.location.href = `${domainName}/servicing/index.html`;
        }
      } else {
        window.location.href = `${domainName}/servicing/index.html`;
        //props.navigation.navigate('HomePage');
      }
      // Linking.openURL(window.location.origin);
    } else {
      this.setState({
        openmodel: false,
        modalopenhide: false,
      });
    }
  };
  gotOService = async data => {
    this.props.navigation.state.params = {};
    this.props.navigation.state.params.flow = data.servicename;
    this.props.navigation.state.params.serviceType = data.serviceType;
    this.props.navigation.state.params.servicename = data.servicename;
    this.props.navigation.state.params.displayName = data.displayName;
    this.props.navigation.state.params.serviceDynamic = data.dynamicStatus;
    this.props.navigation.state.params.menuType = data.dynamicMenuType;
    this.props.navigation.state.params.menuname = data.menuname;
    this.props.navigation.state.params.serviceId = data.serviceId;
    this.props.navigation.state.params.serviceMessageForNoDynamic =
      data.message;
    this.props.navigation.state.params.flag = true;

    if (Platform.OS === 'web') {
      sessionStorage.setItem('flag', 'true');
    } else {
      await AsyncStorage.setItem('flag', 'true');
    }

    this.props.navigation.state.params.headerFlag = true;
    this.props.navigation.state.params.account = 'false';
    this.props.navigation.state.params.mobile = 'true';
    this.props.navigation.state.params.firstpage = 'true';
    this.props.navigation.state.params.shortName1 = 'mob';
    this.props.navigation.state.params.shortName2 = 'pan';
    // this.props.navigation.state.params.subHeading =
    //   data.menuname +
    //   ' - ' +
    //   data.displayName;
    this.props.navigation.state.params.subHeading = data.displayName;
    this.props.navigation.state.params.Optionselected2 = ALL_CONSTANTS.PAN_NUMBER_CONST;
    this.props.navigation.navigate(
      'Verification',
      this.props.navigation.state.params
    );
    // this.props.navigation.navigate(
    //   'Options',
    //   this.props.navigation.state.params
    // );
  };
  render() {
    let props = this.props;
    const searchFlag = true;
    const { measure, showip, isOverdue } = props;
    let Dontshow_Searchoption =
      this.props.Dontshow_Searchoption !== undefined
        ? this.props.Dontshow_Searchoption
        : false;
    let verification =
      this.props.verification !== undefined
        ? this.props.verification
        : false;
    let homeScreen =
      this.props.homeScreen !== undefined
        ? this.props.homeScreen
        : false;
    return (
      <View>
        <View
          style={[
            styles.newTopNavMainView,
            { borderBottomWidth: 1, borderBottomColor: '#F0F0F0' },
            styles[getResponsiveStyle('newTopNavMainView', measure)]
          ]}
        >
          <CustomBootbox
            {...this.props}
            measure={this.state.measure}
            bootboxtext={this.state.bootboxtext}
            headerText={this.state.headerText}
            bootboxmodal={this.state.openmodel}
            closebootbox={this.closebootbox}
            hideBlackout
          />
          <View
            style={[
              styles.newTopNavInnerView,
              styles[getResponsiveStyle('newTopNavInnerView', measure)]
            ]}
          >
            <View
              style={[
                styles.TopNavImage1MainView,
                styles[getResponsiveStyle('TopNavImage1MainView', measure)]
              ]}
            >
              <TouchableOpacity>
              <View
                  style={verification ? styles.logoInVerification : styles.logoDisplay}>
                  <Image
                    style={
                      verification ? [styles.TopNavImage1StyleViewVeri,
                      { height: verification ? 57 : 72 },
                      styles[getResponsiveStyle('TopNavImage1StyleViewVeri', measure)],
                      styles.iciciLogoWidthveri,
                      styles[getResponsiveStyle('iciciLogoWidthveri', measure)],
                      ] :
                        [
                          styles.TopNavImage1StyleView,
                          { height: verification ? 57 : 72 },
                          styles[getResponsiveStyle('TopNavImage1StyleView', measure)],
                          styles.iciciLogoWidth,
                          styles[getResponsiveStyle('iciciLogoWidth', measure)],
                        ]
                    }
                    source={require('../../assets/images/icici-bank-logo.svg')}
                  />
                </View>
              </TouchableOpacity>
            </View>
            {Dontshow_Searchoption ? null : (
              <View
                style={[
                  styles.newTopNavAutoompleteMainview,
                  styles[
                  getResponsiveStyle('newTopNavAutoompleteMainview', measure)
                  ]
                ]}
              >
                <View
                  style={[
                    styles.TopsectionAutocompleteView2,
                    styles[
                    getResponsiveStyle('TopsectionAutocompleteView2', measure)
                    ]
                  ]}
                >
                  {searchFlag === false &&
                    this.state.searchArray.length > 0 ? (
                    <View style={{ width: '100%', flexDirection: 'row' }}>
                      <View style={{ flex: 2 }}>
                        {/* <Slider {...settings}>
                          {this.state.searchArray[0] ?
                            <View>
                              <TouchableOpacity
                                onPress={() =>
                                  this.gotOService(this.state.searchArray[0])
                                }
                              >
                                <Text>{this.state.searchArray[0] ? this.state.searchArray[0].servicename : ''}</Text>
                              </TouchableOpacity>
                            </View> : null}
                          {this.state.searchArray[1] ?
                            <View>
                              <TouchableOpacity
                                onPress={() =>
                                  this.gotOService(this.state.searchArray[1])
                                }
                              >
                                <Text>{this.state.searchArray[1] ? this.state.searchArray[1].servicename : ''}</Text>
                              </TouchableOpacity>
                            </View> : null}
                          {this.state.searchArray[2] ?
                            <View>
                              <TouchableOpacity
                                onPress={() =>
                                  this.gotOService(this.state.searchArray[2])
                                }
                              >
                                <Text>{this.state.searchArray[2] ? this.state.searchArray[2].servicename : ''}</Text>
                              </TouchableOpacity>
                            </View> : null}
                          {this.state.searchArray[3] ?
                            <View>
                              <TouchableOpacity
                                onPress={() =>
                                  this.gotOService(this.state.searchArray[3])
                                }
                              >
                                <Text>{this.state.searchArray[3] ? this.state.searchArray[3].servicename : ''}</Text>
                              </TouchableOpacity>
                            </View> : null}
                          {this.state.searchArray[4] ?
                            <View>
                              <TouchableOpacity
                                onPress={() =>
                                  this.gotOService(this.state.searchArray[4])
                                }
                              >
                                <Text>{this.state.searchArray[4] ? this.state.searchArray[4].servicename : ''}</Text>
                              </TouchableOpacity>
                            </View> : null}
                        </Slider> */}
                      </View>
                      <View
                        style={{
                          paddingHorizontal: '5%',
                          zIndex: -9,
                          width: '10%',
                          marginTop: '1%'
                        }}
                      >
                        <TouchableOpacity onPress={() => this.onSubmit()}>
                          <Image
                            style={{
                              width: 20,
                              height: 20
                            }}
                            resizeMode='contain'
                            source={require('../../assets/images/searchicon.png')}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>
                  ) : (
                    <View
                      style={[
                        styles.TopsectionAutocompleteView3,
                        styles[
                        getResponsiveStyle(
                          'TopsectionAutocompleteView3',
                          measure
                        )
                        ]
                      ]}
                    >
                      <TouchableOpacity onPress={() => this.onSubmit()}>
                        <Image
                          style={{
                            width: 20,
                            height: 20,
                            marginLeft: 2
                          }}
                          resizeMode='contain'
                          source={require('../../assets/images/searchicon.png')}
                        />
                      </TouchableOpacity>
                      <View style ={{width:'96%'}}>
                        <Autocomplete
                          measure={measure}
                          autoCapitalize='none'
                          searchIcon={true}
                          autoCorrect={false}
                          hideResults={props.CloseSelectionDropdown}
                          inputContainerStyle={{
                            borderBottomWidth: null,
                            borderBottomColor: 'transparent',
                            width: measure === 'LAPTOP' ? 580 : 350
                          }}
                          style={[
                            styles.TopsectionAutocompletestyle,
                            styles[
                            getResponsiveStyle(
                              'TopsectionAutocompletestyle',
                              measure
                            )
                            ]
                          ]}
                          data={props.SearchElements}
                          value={props.SelectedDropdownOption}
                          onChangeText={text => {
                            props.searchOptionChange(text);
                          }}
                          placeholder={'Search for service request...'}
                          renderItem={val => (
                            <TouchableOpacity
                              style={[
                                styles.TopsectionAutocompleteButtonstyle,
                                { flexDirection: 'row', alignItems:'baseline' },
                                styles[
                                getResponsiveStyle(
                                  'TopsectionAutocompleteButtonstyle',
                                  measure
                                )
                                ]
                              ]}
                              onPress={() => {
                                props.textInputChange(
                                  val.optionname.toUpperCase(),
                                  val
                                );
                              }}
                            >
                              {measure === 'XXHDPI' ? <View></View> : <Image
                                resizeMode='contain'
                                source={val.images}
                                style={{
                                  width: 25,
                                  height: 25,
                                  marginLeft: 5
                                }}
                              />}
                              <Text
                                style={[
                                  styles.TopsectionAutocompletemenutextstyle,
                                  styles[
                                  getResponsiveStyle(
                                    'TopsectionAutocompletemenutextstyle',
                                    measure
                                  )
                                  ]
                                ]}
                              >
                               {val.menuname}
                              </Text>
                              <Text
                                style={[
                                  styles.TopsectionAutocompleteServicetextstyle,
                                  styles[
                                  getResponsiveStyle(
                                    'TopsectionAutocompleteServicetextstyle',
                                    measure
                                  )
                                  ]
                                ]}
                              >
                           {" - "}{val.optionname}
                              </Text>
                            </TouchableOpacity>
                          )}
                        />
                      </View>
                    </View>
                  )}
                  {/* <Image
                    style={{
                      width: 20,
                      height: 20
                    }}
                    resizeMode='contain'
                    source={require('../../assets/images/searchicon.png')}
                  /> */}
                </View>
              </View>
            )}
            <View
              style={[
                props.verification ?
                  [styles.newTopNavImage2Mainview1,
                  styles[getResponsiveStyle('newTopNavImage2Mainview', measure)]] :
                  styles.newTopNavImage2Mainview,
                styles[getResponsiveStyle('newTopNavImage2Mainview', measure)]
                // styles.newTopNavImage2MainviewOverDue,
                // styles[
                //   getResponsiveStyle('newTopNavImage2MainviewOverDue', measure)
                // ]
              ]}
            >
              {/* <TouchableOpacity>
                            <Image
                                style={[
                                    styles.TopsectionAutocompleteIMagestyle11,
                                    styles[getResponsiveStyle('TopsectionAutocompleteIMagestyle11', measure)],
                                ]}
                                resizeMode='contain'
                                source={require('../../assets/images/26-Smartphone-Status.png')}
                            />
                        </TouchableOpacity> */}
              {showip ? <View>
                <Text
                  style={[
                    styles.TopnavMobileIPText,
                    styles[getResponsiveStyle('TopnavMobileIPText', measure)]
                  ]}
                >
                  IP: {this.state.userIp}
                </Text>
              </View> : null}
              <View style={{ marginTop: 5 }}>
                <Text
                  style={[
                    styles.TopnavMobileIPText,
                    styles[getResponsiveStyle('TopnavMobileIPText', measure)]
                  ]}
                >
                  Location: {this.state.userAddress}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <View
          style={[
            styles.newTopNavbar,
            { backgroundImage: 'linear-gradient(to bottom, #f58e21, #ef6812)', zIndex: -999999999999999 },
            styles[getResponsiveStyle('newTopNavbar', measure)]
          ]}
        ></View>
      </View>
    );
  }
}
Topsection.contextType = AppConsumer;

export default hocComponentFetcherWithLoader()(Topsection);
